<template>
  <div class="add1">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>选择商品分类
      </div>
    </div>
    <div v-if="role">
      <div class="setp">
        <el-steps :active="0" align-center>
          <el-step title="选择商品"></el-step>
          <el-step title="填写商品信息"></el-step>
        </el-steps>
      </div>
      <div style="width: 1056px;margin: 0 auto;background-color: #eee">
        <div class="clear" style="position: relative;">
          <div class="clear-item col1">
            <div class="left_div">
              <i class="fas fa-bookmark fa-lg" style="margin-left:30px;color:white"></i>
              <div class="positi"></div>
              <p>选择分类</p>
            </div>
          </div>
          <div class="clear-item col2" id="c2">
            <el-row class="brand">
              <el-col :span="8">
                <div class="grid-content">
                  <div class="brand-t">选择一级分类</div>
                  <div
                    class="brand-i"
                    v-for="item in brands"
                    :key="item.id"
                    v-show="item.f_id == 0"
                    v-bind:class="{ active: item.id == topId }"
                    @click="setTopId(item.id,item.cate_name)"
                  >
                    <div class="item-n">{{item.cate_name}}</div>
                    <div class="item-r">></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <div class="brand-t">选择二级分类</div>
                  <div
                    class="brand-i"
                    v-for="item in brands"
                    :key="item.id"
                    v-show="item.f_id == topId"
                    v-bind:class="{ active: item.id == secId }"
                    @click="setSecId(item.id,item.cate_name)"
                  >
                    <div class="item-n">{{item.cate_name}}</div>
                    <div class="item-r">></div>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content">
                  <div class="brand-t">选择三级分类</div>
                  <div
                    class="brand-i"
                    v-for="item in brands"
                    :key="item.id"
                    v-show="item.f_id == secId"
                    v-bind:class="{ active: item.id == thiId }"
                    @click="setThiId(item.id,item.cate_name)"
                  >
                    <div class="item-n">{{item.cate_name}}</div>
                  </div>
                </div>
              </el-col>
            </el-row>

            <div style="padding: 20px">
              <button
                class="button"
                style="width: 230px;margin: 0 auto;display: block"
                @click="next()"
              >下一步，填写商品信息</button>
            </div>
          </div>
          <div class="updata">
            <p>上传数据</p>

            <div class="updata_div">
              <div>
                <el-upload
                  style="margin-right:10px"
                  class="upload-demo"
                  action
                  :auto-upload="false"
                  :limit="1"
                  :on-change="handleRemove1"
                >
                  <el-button plain>excel批量上传</el-button>
                </el-upload>
              </div>
              <div>
                <el-button plain @click="temp()">点击下载模板</el-button>
              </div>
            </div>
            <div style="margin-top:20px;">
              <el-button plain @click="sameLike=true">上传同类商品</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <el-dialog title="上传类似商品" :visible.sync="sameLike" width="40%">
      <el-form :model="sameLikeForm">
        <el-form-item label="相似商品ID：" label-width="100px">
          <el-input v-model="sameLikeForm.id" @input="prouduct_alike" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="商品名称：" label-width="100px">
          <el-input v-model="sameLikeForm.title" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="商品货号：" label-width="100px">
          <el-input v-model="sameLikeForm.item_no" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="商品规格：" label-width="100px">
          <el-input v-model="sameLikeForm.specification" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="售价：" label-width="100px">
          <el-input v-model="sameLikeForm.selling_price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="货期：" label-width="100px">
          <el-input v-model="sameLikeForm.leadtime" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="原价：" label-width="100px">
          <el-input v-model="sameLikeForm.original_price" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="sameLike = false">取 消</el-button>
        <el-button type="primary" @click="submitSameLike">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "add2",
  data() {
    return {
      serve: this.$store.state.serve,
      role:true,
      brands: null,
      topId: null,
      secId: null,
      thiId: null,
      name1: null,
      name2: null,
      className: this.className,
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      sameLike: false,
      sameLikeForm: {},
      item_no: "",
      specification: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "添加商品";
    //
  },
  mounted() {
    this.axios
      .get(this.serve + "/admin/get_category", {
        params: {
          username: this.username,
          token: this.token
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          this.brands = res.data.data;
        } else if (res.data.status == "error" && res.data.code == "403") {
          this.role = false;
        }
      })
      .catch(error => {});
  },
  methods: {
    prouduct_alike(id) {
      this.axios
        .get(this.serve + "/admin/likeProductInfo", {
          params: {
            username: this.username,
            token: this.token,
            id: this.sameLikeForm.id
          }
        })
        .then(res => {
          console.log(res);
          if (res.data.status == "success") {
            this.sameLikeForm = res.data.data;
          }
        });
    },
    alert_success(message) {
      this.$message({
        type: "success",
        message: message,
        offset: 200
      });
    },
    alert_error(message) {
      this.$message({
        type: "error",
        message: message,
        offset: 200
      });
    },
    submitSameLike() {
      var qs = require("qs");
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.sameLikeForm.token = this.token;
      this.sameLikeForm.username = this.username;
      this.axios
        .post(
          this.serve + "/admin/uploadSameLike",
          qs.stringify(this.sameLikeForm)
        )
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.alert_success("商品添加成功");
          } else {
            this.alert_error("商品添加失败");
          }
        });
    },
    handleRemove1(file, fileList) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let formData = new FormData();
      formData.append("username", this.username);
      formData.append("token", this.token);
      formData.append("file", file.raw);
      this.axios
        .post(this.serve + "/admin/uploadExcel", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            this.$notify({
              title: "成功",
              message: res.data.msg,
              type: "success",
              duration: 0
            });
          } else if (res.data.status == "error") {
            this.$notify.error({
              title: "失败",
              message: res.data.msg
            });
          }
        });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    temp() {
      window.location.href =
        this.serve +
        "/admin/downLoad_tplt?token=" +
        this.token +
        "&" +
        "username=" +
        this.username;
    },
    next() {
      if (this.thiId != null) {
        this.$router.push({
          name: "admin.product.add1.add2",
          params: {
            id1: this.topId,
            id2: this.secId,
            id3: this.thiId,
            className: this.className,
            name1: this.name1,
            name2: this.name2
          }
        });
      } else {
        this.$message.error("未选择分类");
      }
    },
    setTopId(id, str) {
      this.topId = id;
      this.secId = null;
      this.thiId = null;
      this.name1 = str;
    },
    setSecId(id, str) {
      this.secId = id;
      this.thiId = null;
      this.name2 = str;
    },
    setThiId(id, str) {
      this.thiId = id;
      this.className = str;
    }
  }
};
</script>
<style lang="scss">
.add1 {
  .updata {
    width: 300px;
    height: 100px;
    position: absolute;
    top: 0;
    right: -350px;
    .updata_div {
      display: flex;
      ul {
        width: 150px;
      }
    }
  }
  .brand {
    background-color: #fff;
  }
  .brand-t {
    width: 210px;
    border: 1px solid #ddd;
    line-height: 45px;
    background-color: #f5faf9;
    margin: 0 auto;
    margin-bottom: -1px;
    border-radius: 10px 10px 0 0;
  }
  .brand-i {
    width: 210px;
    border: 1px solid #ddd;
    line-height: 36px;
    background-color: #fff;
    margin: 0 auto;
    text-align: left;
    font-size: 14px;
    line-height: 1.5em;
    padding: 10px 0;
    margin-bottom: -1px;
  }
  .brand-i:hover,
  .active {
    background-color: #eee;
    color: #0099ff;
    font-weight: bold;
  }
  .brand-i .item-n {
    margin-left: 10px;
  }
  .item-r {
    position: relative;
    line-height: 36px;
    float: right;
    top: -26px;
    right: 10px;
  }
  .brand {
    text-align: center;
  }
  .col1 {
    width: 182px;
    background-color: #eee;
    padding-top: 100px;
    text-align: center;
    // position: relative;
    // .positi {
    //   width: 0;
    //   height: 0;
    //   border-top: 27px dashed transparent;
    //   border-bottom: 27px dashed transparent;
    //   border-left: 24px solid rgba(166, 182, 193, 1);
    //   font-size: 0;
    //   position: absolute;
    //   top: 0;
    //   right: -24px;
    // }
    .left_div {
      width: 182px;
      height: 54px;
      background: rgba(166, 182, 193, 1);
      position: absolute;
      left: 0;
      top: 80px;
      display: flex;
      position: relative;
      align-items: center;
      .positi {
        z-index: 1;
        width: 0;
        height: 0;
        border-top: 27px dashed transparent;
        border-bottom: 27px dashed transparent;
        border-left: 24px solid rgba(166, 182, 193, 1);
        font-size: 0;
        position: absolute;
        top: 0;
        right: -24px;
      }
      > p {
        // display: inline-block;
        margin-left: 6px;
        font-size: 18px;
        font-family: "MicrosoftYaHei";
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-align: center;
      }
    }
    .item {
      background-color: #a6b6c1;
      color: #fff;
      font-size: 17px;
      padding: 18px 0;
    }
    display: block;
    height: 100%;
  }
  .col2 {
    width: 870px;
    background-color: #fff;
    padding-top: 30px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }

  .setp {
    width: 800px;
    margin: 35px auto;
  }
}
#app .layout .right .right {
  background-color: #fff;
}
</style>